import { Tipo_recepcion } from './../../../models/tipo_recepcion.model';
import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: "page-tipo_recepcion",
    templateUrl: "./tipo_recepcion.component.html"
})

export class Tipo_recepcionComponent {
    public rows = [];
    public actualRow;
    public tipo_recepcion: Tipo_recepcion;
    public form;
    public tipos: string[] =['RECEPCION DEFINITIVA PARCIAL','RECEPCION DEFINITIVA TOTAL'];

    constructor(private fb: FormBuilder){

        this.form = new FormGroup({
            option: new FormControl('', Validators.required)
        })

        if(!JSON.parse(localStorage.getItem("tipo_recepcion"))){
            localStorage.setItem("tipo_recepcion", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_recepcion"));

            this.form.controls['option'].setValue(this.rows[0]?this.rows[0].option:false);
        }

       
    }
    add_tipo_recepcion(event){
        var checkTipoRecepcion = event.value;
        localStorage.setItem("tipo_recepcion",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_recepcion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            option: checkTipoRecepcion
            
          
        })
        localStorage.setItem("tipo_recepcion", JSON.stringify(this.rows));
        console.log(localStorage.getItem("tipo_recepcion"))
    }
  
    delete_tipo_recepcion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_recepcion", JSON.stringify(this.rows));
            }
        }
    }  
}